import React from 'react';
import DemoLessonPlanDetail from '../demo/DemoLessonPlanDetail';

const LiteLessonPlanDetail = ({ user, onLogout }) => {
  return <DemoLessonPlanDetail user={user} onLogout={onLogout} isDemoMode={true} />;
};

export default LiteLessonPlanDetail;
